import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import SmartRender from "containers/SmartRender";
import {
  makeSelectSwitchToEsimForm,
  makeSelectSwitchToEsimPayload,
  makeSelectPageValidations,
  makeSelectSwitchToEsimValues
} from "ducks/selectors";
import { changeFormField, submitSwitchToEsim } from "ducks/actions";
import validate, { asyncValidate } from "validations";
import { forms } from "utils/constants";
import styles from "./styles";

const mapStateToProps = (state, props) =>
  createStructuredSelector({
    styles: () => styles,
    formValues: makeSelectSwitchToEsimForm(),
    payload: makeSelectSwitchToEsimPayload(),
    formValidations: makeSelectPageValidations("submitReplaceSim"),
    initialValues: makeSelectSwitchToEsimValues()
  });

export const mapDispatchToProps = dispatch => {
  return {
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.SWITCH_TO_ESIM_FORM,
          field: field,
          value: value
        })
      );
    },
    onSubmit: (navigate, payload) => {
      dispatch(
        submitSwitchToEsim(payload, (result, error) => {
          if (!error) {
            try {
              navigate();
            } catch (err) {
              console.error("Error on submitReplaceSim callback", err);
            }
          } else {
            console.error("Error on switch to esim callback", error);
          }
        })
      );
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.SWITCH_TO_ESIM_FORM,
    destroyOnUnmount: false,
    validate,
    asyncValidate
  }),
  memo
)(SmartRender);
